import {
  VStack,
  colors,
  Spacing,
  getCdnImageSrc,
  Image,
  customEvent,
} from "goi_common";
import { Box } from "@chakra-ui/react";
import HomeV4BenefitCard from "./HomeV4BenefitCard";
import { useRouter } from "next/router";

export default function HomeV4BenefitSection() {
  const router = useRouter();

  return (
    <VStack padding="80px 20px 0px 20px">
      <VStack
        alignItems="center"
        css={{
          textAlign: "center",
        }}
      >
        <Box className="body_16_r" color={colors.gray700}>
          고이와 함께 시작하는 장례 준비
        </Box>
        <Spacing gap={8} />
        <Box className="subtitle_21_sb" color={colors.gray900}>
          타 상조 대비 절반의 가격으로
          <br /> 장례 준비하세요
        </Box>
      </VStack>

      <Spacing gap={34} />

      <VStack>
        <HomeV4BenefitCard
          top={
            <>
              매년 3~5%씩 오르는 장례 비용 <br />
              지금 가입하면 <b>현재 비용 평생 보장</b>받아요.
            </>
          }
          middle={
            <Image
              src={getCdnImageSrc(
                "images/package-price/289/prime/chart-price-lock-goi-289.png"
              )}
              alt="지금 가격 평생 보장"
            />
          }
          onClick={() => {
            customEvent({
              newGtm: {
                path: "home",
                trigger_and_target: "uv_detail",
              },
            });
            router.push("/content/feeds/goisangjo/");
          }}
        />
        <Spacing gap={16} />
        <HomeV4BenefitCard
          top={
            <>
              거품을 없앤 장례
              <br />
              <b>가격을 50%로 낮췄어요.</b>
            </>
          }
          middle={
            <Image
              src={getCdnImageSrc(
                "images/package-price/289/prime/compare-price-289.png"
              )}
              alt="가격을 50%로 낮췄어요"
            />
          }
          buttonText="보장 상품 자세히 보기"
          onClick={() => {
            router.push("/service/");
            customEvent({
              newGtm: {
                path: "home",
                trigger_and_target: "uv_service",
              },
            });
          }}
        />
      </VStack>
    </VStack>
  );
}
